import { render, staticRenderFns } from "./SocialWallPostMedia.vue?vue&type=template&id=31cd7049&scoped=true"
import script from "./SocialWallPostMedia.vue?vue&type=script&lang=js"
export * from "./SocialWallPostMedia.vue?vue&type=script&lang=js"
import style0 from "./SocialWallPostMedia.vue?vue&type=style&index=0&id=31cd7049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd7049",
  null
  
)

export default component.exports